<template>
  <div style="position: absolute;
    right: 28vw;
    width: 51vw; height: 20vw;" class="card-panel-main col-lg-9 mb-5">

<!--    <BehfamLOGO style="position:absolute; top: 10vw; right: 37vw; z-index: 99999999"/>-->
  </div>
</template>
<script  >
import {defineComponent} from "vue";
import BehfamLOGO from "@/components/Icons/BehfamLOGOEmpty.vue";

export default defineComponent({
  components: {BehfamLOGO}
})
</script>